var _rect, _rect2, _rect3, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 950,
    transform: "translate(-880 -268)",
    fill: "#00A4BD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -604,
    y: -232,
    width: 1608,
    height: 878,
    rx: 8,
    fill: "#FEFEFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 40,
    transform: "translate(-124 -12)",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00658 13.6671L2.65991 10.3271",
    stroke: "#4C488F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00659 2.33301V13.6663",
    stroke: "#4C488F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99341 2.33301L13.3401 5.67301",
    stroke: "#4C488F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99341 13.6663V2.33301",
    stroke: "#4C488F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98203 26L6.09542 24.6453C5.49003 23.7203 4.20052 23.3829 3.21416 23.89L3.44399 23.7718C3.1992 23.8977 3.08183 24.2114 3.18261 24.4721L4.40988 27.6474C4.60444 28.1508 5.10134 28.8627 5.5131 29.2203C5.5131 29.2203 7.98203 31.2639 7.98203 32.03V33H11.982H13.0758H13.982H14.982V32.03C14.982 31.2639 16.4909 28.8507 16.4909 28.8507C16.7686 28.3816 17.0001 27.5552 17.0001 27.0066V22.9718C16.982 22.0785 16.2227 21.3545 15.2857 21.3545C14.817 21.3545 14.4373 21.7165 14.4373 22.1634V22.4866C14.4373 21.5933 13.678 20.8693 12.7411 20.8693C12.2723 20.8693 11.8927 21.2313 11.8927 21.6782V22.0013C11.8927 21.108 11.1333 20.3841 10.1964 20.3841C9.72765 20.3841 9.34798 20.7461 9.34798 21.193V21.5161C9.34798 21.3726 9.33264 21.2584 9.30299 21.168L9.04421 17.0012C9.00922 16.4378 8.53432 16 7.98203 16C7.4259 16 6.98203 16.4476 6.98203 16.9998V21V26Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95367 23.3833C2.58631 23.6978 2.4454 24.229 2.62296 24.6885L3.85023 27.8637C4.07968 28.4574 4.63323 29.2508 5.11966 29.6733L5.12504 29.678L5.13047 29.6825L2.95367 23.3833ZM2.95367 23.3833L2.93983 23.3564L2.95367 23.3833ZM5.13052 29.6825L5.13064 29.6826L5.13164 29.6835L5.13624 29.6873L5.15544 29.7033C5.17253 29.7176 5.19799 29.7391 5.23063 29.7668C5.29593 29.8223 5.38979 29.9029 5.50264 30.0021C5.72895 30.2012 6.0288 30.4727 6.32698 30.7658C6.62782 31.0615 6.91441 31.3669 7.12162 31.6348C7.22552 31.7692 7.29908 31.8809 7.34416 31.9672C7.36901 32.0147 7.37867 32.0422 7.38203 32.0525V33V33.6H7.98203H11.982H13.0758H13.982H14.982H15.582V33V32.03C15.582 32.0303 15.582 32.0261 15.583 32.0165C15.584 32.0071 15.5859 31.9941 15.589 31.9772C15.5953 31.9429 15.6059 31.8986 15.6222 31.8438C15.6549 31.7334 15.7048 31.5987 15.7703 31.444C15.9012 31.1348 16.0799 30.78 16.2645 30.438C16.448 30.0978 16.6323 29.7797 16.771 29.5461C16.8403 29.4295 16.8979 29.3344 16.9379 29.2688L16.9842 29.1936L16.996 29.1745L16.9989 29.1699L16.9995 29.1689L16.9996 29.1688L5.13052 29.6825Z",
    stroke: "#363B3E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -1.05322,
    y: 12.7998,
    width: 22.2534,
    height: 25.4004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -556,
    y: -12,
    width: 1512,
    height: 586,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.8313abca826237662df2021c79c25653.svg";
export { ForwardRef as ReactComponent };